import {CSSProperties, FC} from 'react';


export interface IIconSearchNissanProps {
    className?: string;
    color?: string;
    size?: string;
    style?: CSSProperties;
}

export const IconSearchNissan: FC<IIconSearchNissanProps> = (props) => {
    const {
        className,
        color,
        size,
        style = {},
    } = props;

    /* eslint-disable max-len */
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            className={className}
            fill="currentColor"
            width="1em"
            height="1em"
            style={{
                display: 'inline-block',
                flexShrink: 0,
                color,
                fontSize: size,
                lineHeight: '1em',
                ...style,
            }}
        >
            <path fillRule="evenodd" d="m19.775 18.651-2.966-2.944a7.205 7.205 0 0 0-.811-9.869 7.192 7.192 0 0 0-9.89.271 7.205 7.205 0 0 0-.271 9.898 7.192 7.192 0 0 0 9.86.812l2.943 2.944a.8.8 0 0 0 1.135 0 .8.8 0 0 0 0-1.112Zm-8.563-1.832a5.599 5.599 0 0 1-5.596-5.601c0-3.093 2.505-5.601 5.596-5.601a5.603 5.603 0 0 1 3.957 9.561 5.595 5.595 0 0 1-3.957 1.64Z" clipRule="evenodd" />
        </svg>
    );
};
